"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCode = exports.getValidateCodePath = void 0;
const axios_client_1 = require("@invivodf/axios-client");
const getValidateCodePath = (checkoutId) => `/v2/bff/appro/checkouts/${checkoutId}/validateCode`;
exports.getValidateCodePath = getValidateCodePath;
const validateCode = (client) => async ({ checkoutId, validationCode }) => {
    return (0, axios_client_1.httpResultWrapper)(() => client.post((0, exports.getValidateCodePath)(checkoutId), { validationCode }));
};
exports.validateCode = validateCode;
